import { PensionAccountType } from 'apps/user/types/on-boarding.type';
import { AxiosError, AxiosInstance } from 'axios';
import { BeneficiariesAllocationDto } from 'service/dto/general.dto';
import {
  AssignBeneficiaryDto,
  PensionAccount,
  PensionAccounts
} from 'service/dto/pension-account.dto';
import { errorHandler } from 'utils';

class PensionService {
  private baseService: AxiosInstance;

  constructor(baseService: AxiosInstance) {
    this.baseService = baseService;
  }

  createPension = async (pensionAccountType: PensionAccountType) => {
    try {
      const response = await this.baseService.post(
        '/pension-account/create',
        pensionAccountType
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getPensionAccounts = async (): Promise<PensionAccounts> => {
    try {
      const response = await this.baseService.get('/pension-account');
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  getPensionAccount = async (pensionId: number): Promise<PensionAccount> => {
    try {
      const response = await this.baseService.get(
        `/pension-account/${pensionId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  deletePensionAccount = async (pensionId: number): Promise<void> => {
    try {
      const response = await this.baseService.delete(
        `/pension-account/${pensionId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  assignBeneficiary = async (assignBeneficiaryDto: AssignBeneficiaryDto) => {
    try {
      const response = await this.baseService.patch(
        '/pension-account/assign-to-beneficiary',
        assignBeneficiaryDto
      );
      return response?.data;
    } catch (error: any) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  unAssignPensionBeneficiary = async (allocationId?: number): Promise<void> => {
    try {
      const response = await this.baseService.delete(
        `/pension-account/unassign-beneficiary/${allocationId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  editBulkPensionBeneficiary = async (
    beneficiariesAllocationDto?: BeneficiariesAllocationDto
  ): Promise<void> => {
    try {
      const response = await this.baseService.patch(
        `/pension-account/bulk-edit-beneficiary-assign`,
        beneficiariesAllocationDto
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  removePensionTrustee = async (
    assetId: number,
    trusteeId: number
  ): Promise<void> => {
    try {
      const response = await this.baseService.delete(
        `/pension-account/unassign-trustee/${assetId}/${trusteeId}`
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };

  assignPensionTrustee = async (
    assetId: number[],
    trusteeId: number,
    note: string
  ): Promise<void> => {
    try {
      const response = await this.baseService.put(
        `/pension-account/assign/bulk-trustee`,
        {
          assetId,
          trusteeId,
          note
        }
      );
      return response.data;
    } catch (error) {
      const err = error as AxiosError<Error>;
      return errorHandler(err);
    }
  };
}
export default PensionService;
